<template>
    <label class="mb-0">
        <slot name="labelText">{{ 'Total file size per conversion' | trans }}:<br /></slot>
        <select class="bg-white px-2 py-1 mt-2" v-model="selectedSize" :disabled="disabled">
            <option
                v-for="(label, size) in selectableSizes"
                :value="size"
                :disabled="isDayBillingSelected && size < 1000"
            >
                {{ label }}
            </option>
        </select>
    </label>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';

export default {
    name: 'SelectFileSizeDropdown',
    mixins: [TransFilter],
    props: {
        isDayBillingSelected: {
            type: Boolean,
            required: true,
        },
        selectableSizes: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: '200',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        selectedSize(size, oldSize) {
            if (size === oldSize) {
                // no need to emit event if the value didn't change
                return;
            }

            this.$emit('input', size);
        },
        isDayBillingSelected(isDay) {
            if (!isDay) {
                return;
            }

            // if user selected the 24h pass we need to make sure that the selected conversion size is not below 1GB

            const sizeInt = Number.parseInt(this.selectedSize);
            if (sizeInt >= 1000) {
                return;
            }

            // force set selected size
            this.selectedSize = '1000';
        },
    },
    data() {
        return { selectedSize: this.value };
    },
};
</script>
